import ReactJson from '@microlink/react-json-view';

import { withStyles } from '@mui/styles';
import useNotifications from '../_lib/notifications/useNotifications';

const JsonViewer = (props: any) => {
  const notifications = useNotifications();
  let json = { message: 'No Event Details Available' };

  if (props.jsonData) {
    try {
      const formattedJsonData = props.jsonData
        .replace(/\\"/gi, "'") // replaces \\" with '
        .replace(/\\/gi, '');

      json = JSON.parse(formattedJsonData);
    } catch {
      notifications.show({
        type: 'error',
        title: 'Error occurred when parsing JSON data',
      });
    }
  }

  return (
    <div className={props.classes.jsonViewer}>
      <ReactJson
        src={json}
        theme="ocean"
        displayDataTypes={false}
        displayObjectSize={false}
        enableClipboard={false}
      />
    </div>
  );
};

const styles = () => {
  return {
    jsonViewer: {
      width: '100%',
    },
  };
};

export default withStyles(styles)(JsonViewer);
